export const QR_CODE_SETTINGS_DEFAULTS = {
    code_color: '#000000',
    background_color: '#FFFFFF',
    image_format: 'png',
    width: undefined,
    margin: undefined,
    center_logo_url: undefined,
    code_pattern: 1,
    finder_pattern: 1,
    finder_pattern_color: '#000000',
    background_image_url: undefined,
    background_image_opacity: undefined,
    code_pattern_url: undefined,
};
//# sourceMappingURL=QrCodeSettingsDefaults.js.map